<template>
  <div class="part">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="操作人">
          <el-input v-model="filters.createBy" clearable></el-input>
        </el-form-item>
        <el-form-item label="操作模块">
          <el-select v-model="filters.operateModule" clearable="" placeholder="选择操作模块">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="filters.operateType" clearable="" placeholder="选择操作类型">
            <el-option v-for="(item,index) in types" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间">
          <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="createBy" label="操作人" width="200"></el-table-column>
        <el-table-column prop="createTime" label="操作时间" width="200"></el-table-column>
        <el-table-column prop="operateModule" label="操作模块" width="200"></el-table-column>
        <el-table-column prop="operateType" label="操作类型" width="200"></el-table-column>
        <el-table-column prop="operateDetails" label="操作内容"></el-table-column>
        <!-- <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="medium" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "registrationlogData",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      formData: {
        positionName: "",
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      positionId: '',
      options: [{
        value: '美容外科手术表',
        label: '美容外科手术表'
      }, {
        value: '注射微整科手术表',
        label: '注射微整科手术表'
      },],
      types: [{
        value: '编辑',
        label: '编辑'
      }, {
        value: '导出',
        label: '导出'
      }, {
        value: '删除',
        label: '删除'
      }],
      tableHeight: '',
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 新增部位
    add() {
      this.dialogFormVisible = true
      // 新增置空
      this.formData = {}
      this.positionId = ''
    },
    // 删除部位
    del() {
      var data = this.multipleSelection
      var id = []
      data.map(function (item, index) {
        id.push(item.id)
      })
      this.$confirm('确定要删除选中的数据吗？', '删除部位', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/position/deletePosition", {
            positionIds: id.toString()
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    closs() {
      this.dialogFormVisible = false
    },
    // 确定新增
    doAddgoods() {
      //请求新增账号接口
      let empId = Lockr.get("skinEmpId")
      if (!this.positionId) {
        // 新增部位接口
        let data = {
          positionName: this.formData.positionName,
          userId: empId
        }
        api.requestQuiet("/position/insertPosition", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "新增成功")
            this.query(this.filters.pagination.page)
          } else {
            this.dialogFormVisible = false
            _g.toast("error", "新增失败")
            this.query(this.filters.pagination.page)
          }
        })
      } else {
        // 修改部位接口
        let data = {
          positionId: this.positionId,
          positionName: this.formData.positionName,
          userId: empId
        }
        api.requestQuiet("/position/updatePosition", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "修改成功")
            this.query(this.filters.pagination.page)
          } else {
            this.dialogFormVisible = false
            _g.toast("error", "修改失败")
            this.query(this.filters.pagination.page)
          }
        })
      }

    },
    handleEdit(index, row) {
      this.dialogFormVisible = true
      this.positionId = row.id
      this.formData = JSON.parse(JSON.stringify(row))
      // console.log(index, row);
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        createBy: this.filters.createBy,
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
        operateModule: this.filters.operateModule,
        operateType: this.filters.operateType,
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.request('/register/findRegisterLogPage', querys, (res) => {
        // console.log(res)
        this.tableData = res.data.list
        this.filters.pagination.total = parseInt(res.data.count)
      })
    },
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 400
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.sp1 {
  display: block;
}

.p1 {
  display: inline-block;
  color: #6e6e6e;
  font-size: 20px;
}

.p2 {
  display: inline-block;
  font-size: 20px;
  color: #000000;
  padding-left: 20px;
}

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialogItem >>> .el-input__inner {
  width: 411px;
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
</style>